import { useQuery, useQueryClient } from "@tanstack/react-query";

import { CommentRead } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

import { PublicatonMapId } from "@/features/publications";

import { createItemUpdaterForQueryLists } from "./hooks/create-item-updater-for-query-list";
import { fetchAllPages } from "./utils/fetch-all-pages";

// LIST

const getPublicationCommentListQuery = (publicationId: string, mapId: PublicatonMapId) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["publication-threads", "comments", "list", publicationId, mapId],
    queryFn: async () => {
      if (!mapId) throw new Error("Never happens");
      return fetchAllPages((args) =>
        getRanaApiV1().PublicationCommentsApi.commentList({
          publicationId,
          mapId,
          orderBy: "-created_at",
          ...args,
        })
      );
    },
    refetchInterval: 1000 * 10,
    enabled: !!mapId,
  });
};

export const usePublicationCommentListQuery = (publicationId: string, mapId: PublicatonMapId) => {
  return useQuery(getPublicationCommentListQuery(publicationId, mapId));
};

// INVALIDATION

export const useInvalidatePublicationCommentListQuery = () => {
  const queryClient = useQueryClient();

  return async (publicationId: string, mapId: number) => {
    await queryClient.invalidateQueries({
      queryKey: getPublicationCommentListQuery(publicationId, mapId).queryKey,
      refetchType: "all",
    });
  };
};

export const useUpdatePublicationCommentListQuery = (publicationId: string) => {
  const queryClient = useQueryClient();
  return createItemUpdaterForQueryLists<CommentRead>(queryClient, {
    getQueryKey: () => getPublicationCommentListQuery(publicationId, 0).queryKey.slice(0, -1), // Remove map id from query key
  });
};
